const STORAGE_KEY = "entries:readIds";

export function isItemRead(id: string): boolean {
    if (!id) return false;

    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return false;

        const readIds: string[] = JSON.parse(raw);
        return Array.isArray(readIds) && readIds.includes(id);
    } catch {
        return false;
    }
}

export function markItemAsRead(id: string): void {
    if (!id) return;

    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        const readIds: string[] = raw ? JSON.parse(raw) : [];

        if (!Array.isArray(readIds)) {
            localStorage.setItem(STORAGE_KEY, JSON.stringify([id]));
            return;
        }

        if (readIds.includes(id)) return;

        readIds.push(id);

        localStorage.setItem(STORAGE_KEY, JSON.stringify(readIds));
    } catch {
        // reset storage if corrupted
        localStorage.setItem(STORAGE_KEY, JSON.stringify([id]));
    }
}

export function getAllReadEntryIds(): string[] {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return [];

        const readIds = JSON.parse(raw);

        return Array.isArray(readIds) ? readIds : [];
    } catch {
        return [];
    }
}

export function removeItemFromRead(id: string): void {
    if (!id) return;

    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return;

        const readIds: string[] = JSON.parse(raw);
        if (!Array.isArray(readIds)) return;

        const updated = readIds.filter((storedId) => storedId !== id);

        localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
    } catch {
        // ignore silently – storage might be corrupted
    }
}
